import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthenticationService {
    user: any = [];
    private subject = new Subject<any>();
    keepAfterNavigationChange = false
    constructor() {
    }
    isLoggedIn(isLoggedIn: boolean, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next(isLoggedIn);
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem("currentUserId");
        this.isLoggedIn(false);
        // signOut.handleSignedOutUser();
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/authentication.service.ts